import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { GlobalVariable } from 'app/main/globals';

@Injectable({
  providedIn: 'root'
})
export class AspRequestWishlistService {

  constructor(private http: HttpClient) { }

  createRequest(payload: any[]): Observable<any> {
    return this.http.post(`${GlobalVariable.BASE_API_URL}/request/create`, payload);
  }
  
}